import { updateField } from './updateField';
export const handleDrop = ({
  options = [],
  formField = {},
  handleUpdate = () => {}
}) => handleUpdate(updateField(formField, 'options', options));